import 'pixi.js/math-extras';
import {Vehicule} from "./Vehicule";

// Constructor
export class GameCWalker extends Vehicule {

  constructor(id, index, game, startsHidden) {
    super(id, index, game);

    this.type = "walkers";

    this.speed = 0.5;
    this.bicycleMovingSpeed = -6; // speed while walking in case of GameC
    this.currentSpeed = this.speed;
    this.targetSpeed = this.speed;

    this.floatingRange = 2;
    this.scalingRange = {min: 1, max: 1}; // not working as expected so leave as same value for both

    this.rightLimit = this.game.appWidth + 180;
    this.leftLimit = -180;

    this.posYRange = {min: 150, max: 350}; // from bottom

    this.spawn(startsHidden);
  }

  getRandomTexture() {
    return "pedestrian-" + window.getRandomInt(1, 6);
  }

}
